module.exports = __webpack_public_path__ + "img/small.85cd3ceb.jpg";